<div class="sidenav-menu-outer">
  <div id="vertical-menu" class="menu-content">
    <div class="menu-items-container">
      <!-- Dynamic Program Navigation Items -->
      @for (program of programs(); track program.programId) {
        @if (shouldDisplayProgramInNav(program) && (program.navRoute || program.slug)) {
          <div class="menu-item" [class.collapsed]="isCollapsed">
            <a
              mat-button
              [routerLink]="getProgramRoute(program)"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: false }"
              [matTooltip]="getProgramDisplayName(program)"
              matTooltipPosition="after"
              [matTooltipDisabled]="!isCollapsed"
              (click)="closeSubMenus()"
              [id]="'menu-item-program-' + program.programId"
              [class.collapsed]="isCollapsed"
            >
              <mat-icon class="menu-icon">{{ getProgramIcon(program) }}</mat-icon>
              <span class="menu-title">{{ getProgramDisplayName(program) }}</span>
            </a>
          </div>
        }
      }

      <!-- Admin Menu -->
      @if (isInRole(enums.role.shiftAdmin)) {
        <div class="admin-menu-divider"></div>
      }

      @if (isInRole(enums.role.shiftAdmin)) {
        <!-- Dealers -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/retailers']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Retailers"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">directions_car</mat-icon>
            <span class="menu-title">Retailers</span>
          </a>
        </div>

        <!-- Programs -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/programs']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Programs"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">paid</mat-icon>
            <span class="menu-title">Programs</span>
          </a>
        </div>

        <!-- Manufacturers -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/manufacturers']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Manufacturers"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-manufacturers'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">factory</mat-icon>
            <span class="menu-title">Manufacturers</span>
          </a>
        </div>

        <!-- Brands -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/brands']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Brands"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-brands'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">label</mat-icon>
            <span class="menu-title">Brands</span>
          </a>
        </div>

        <!-- Note Types -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/note-types']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="NoteTypes"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">note</mat-icon>
            <span class="menu-title">Note Types</span>
          </a>
        </div>

        <!-- Disposition Maps -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/disposition-maps']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="NoteTypes"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">map</mat-icon>
            <span class="menu-title">Disposition Maps</span>
          </a>
        </div>

        <!-- Call Center Phone Numbers -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/call-center-phone-number']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="NoteTypes"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">phone</mat-icon>
            <span class="menu-title">Call Center</span>
          </a>
        </div>

        <!-- Users -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/users']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Users"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-11'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">people</mat-icon>
            <span class="menu-title">Users</span>
          </a>
        </div>

        <!-- Retailer Phone Numbers -->
        <div class="menu-item" [class.collapsed]="isCollapsed">
          <a
            mat-button
            [routerLink]="['/retailer-phone-numbers/search']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Retailer Phone Numbers"
            matTooltipPosition="after"
            [matTooltipDisabled]="!isCollapsed"
            (click)="closeSubMenus()"
            [id]="'menu-item-10'"
            [class.collapsed]="isCollapsed"
          >
            <mat-icon class="menu-icon">phone</mat-icon>
            <span class="menu-title">Phone Numbers</span>
          </a>
        </div>

        @if (canAccessLeads()) {
          <div class="menu-item" [class.collapsed]="isCollapsed">
            <a
              mat-button
              [routerLink]="['/leads']"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: false }"
              matTooltip="Leads"
              matTooltipPosition="after"
              [matTooltipDisabled]="!isCollapsed"
              (click)="closeSubMenus()"
              [id]="'menu-item-leads'"
              [class.collapsed]="isCollapsed"
            >
              <mat-icon class="menu-icon">fact_check</mat-icon>
              <span class="menu-title">Leads</span>
            </a>
          </div>

          <div class="menu-item" [class.collapsed]="isCollapsed">
            <a
              mat-button
              [routerLink]="['/dispositions']"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: false }"
              matTooltip="Dispositions"
              matTooltipPosition="after"
              [matTooltipDisabled]="!isCollapsed"
              (click)="closeSubMenus()"
              [id]="'menu-item-dispositions'"
              [class.collapsed]="isCollapsed"
            >
              <mat-icon class="menu-icon">fact_check</mat-icon>
              <span class="menu-title">Dispositions</span>
            </a>
          </div>
        }
      }
    </div>
  </div>
  <!-- Add collapse button at the bottom -->
  <div class="sidenav-collapse-btn">
    <button mat-button (click)="toggleSidenavCollapse()" class="collapse-button">
      <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>
</div>
